<template>
  <svg
    preserveAspectRatio="none"
    width="100%"
    height="100%"
    overflow="visible"
    style="display: block"
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="&#228;&#184;&#139;&#229;&#141;&#149;">
      <g id="Vector">
        <path
          d="M32.1205 5.27203C34.4235 5.27203 34.4235 8.63207 32.1205 8.63207H6.905C5.9415 8.63207 5.09545 9.43101 5.09545 10.3239V43.9718C5.09552 44.8646 5.94154 45.6634 6.905 45.6634H25V49H6.905C3.9205 49 1.5 46.7443 1.5 43.9481V10.3239C1.5 7.52775 3.9205 5.27203 6.905 5.27203H32.1205Z"
          fill="var(--fill-0, white)"
        />
        <path
          d="M28.5725 28.8161C27.5794 29.7789 26.7554 30.9149 26.1502 32.1762H10.5005C8.19751 32.1761 8.19751 28.8162 10.5005 28.8161H28.5725Z"
          fill="var(--fill-0, white)"
        />
        <path
          d="M41.1445 17.044C41.1446 14.8823 44.74 14.8823 44.74 17.044V25.5029H41.1445V17.044Z"
          fill="var(--fill-0, white)"
        />
        <path
          d="M21.3105 18.7358C23.6135 18.7123 23.6135 22.0958 21.3105 22.0958H10.5005C8.19751 22.0958 8.19751 18.7359 10.5005 18.7358H21.3105Z"
          fill="var(--fill-0, white)"
        />
        <path
          d="M45.3509 2.47578C46.0794 1.84138 47.2074 1.84143 47.9359 2.47578C48.5469 3.11021 48.6645 3.79167 48.218 4.52008L47.9359 4.89594L30.0291 21.6025C29.3006 22.2369 28.1726 22.2369 27.4441 21.6025C26.7626 20.8741 26.7626 19.9108 27.4441 19.1823L45.3509 2.47578Z"
          fill="var(--fill-0, white)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M37.925 27.8526C43.7654 27.8526 48.5 32.5866 48.5 38.4263C48.5 44.266 43.7654 49 37.925 49C32.0846 49 27.35 44.266 27.35 38.4263C27.35 32.5866 32.0846 27.8526 37.925 27.8526ZM36.0294 31.3772C35.9246 31.3772 35.8224 31.409 35.7361 31.4683C35.6498 31.5276 35.5836 31.6118 35.5463 31.7095L32.7894 38.9291C32.6605 39.2665 32.9103 39.6282 33.2725 39.6282H36.0471L34.668 44.8254C34.5284 45.3519 35.1963 45.7067 35.5564 45.2971L42.9656 36.8742C43.2586 36.541 43.0216 36.0186 42.5773 36.0186H39.5551L41.1604 32.0874C41.2989 31.7482 41.0487 31.3772 40.6817 31.3772H36.0294Z"
          fill="var(--fill-0, white)"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'OrderPayLater',
} as DefineComponent
</script>
